const carouselItems = [
  {
    title: '顶流男星深夜密会神秘女子，经纪人紧急公关',
    summary: '据知情人士透露，某顶流男星近日被拍到深夜与一名神秘女子共同进出某高档酒店，随后经纪人团队连夜启动危机公关。',
    tag: '独家爆料',
    tagColor: 'bg-primary-500',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20with%20warm%20crimson%20and%20amber%20neon%20lighting%2C%20abstract%20silhouettes%2C%20paparazzi%20camera%20flash%20effects%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20clean%20minimal%20background%2C%20editorial%20photography%20style%2C%20high%20drama&width=640&height=420&seq=carousel-01&orientation=landscape',
  },
  {
    title: '某女团成员被曝与经纪公司合约纠纷升级',
    summary: '知情人士爆料某知名女团核心成员与经纪公司因分成问题产生严重分歧，合约纠纷已持续数月，或将影响团队后续活动。',
    tag: '合约风波',
    tagColor: 'bg-accent-500',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20legal%20document%20scene%20with%20stage%20spotlights%20in%20background%2C%20warm%20amber%20and%20crimson%20gradient%20lighting%2C%20abstract%20geometric%20shapes%2C%20conflict%20tension%20atmosphere%2C%20editorial%20photo%20style%2C%20clean%20composition%2C%20dramatic%20shadows&width=640&height=420&seq=carousel-02&orientation=landscape',
  },
  {
    title: '知名导演新片片场爆发激烈争吵，拍摄一度中断',
    summary: '某知名导演正在拍摄的新片近日因主演与导演在创作理念上产生严重分歧，片场爆发激烈争吵，导致拍摄工作一度中断数小时。',
    tag: '片场直击',
    tagColor: 'bg-secondary-500',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20film%20set%20scene%20with%20cinema%20lighting%20equipment%2C%20warm%20crimson%20and%20amber%20mood%20lighting%2C%20abstract%20silhouettes%20of%20crew%20members%2C%20tense%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20background%2C%20cinematic%20composition&width=640&height=420&seq=carousel-03&orientation=landscape',
  },
  {
    title: '直播带货翻车！某网红卖假货被当场揭穿',
    summary: '近日某知名带货主播在直播中推销的某品牌产品被网友当场扒出与正品不符，直播间评论区瞬间炸锅，该主播仓促下播。',
    tag: '直播翻车',
    tagColor: 'bg-primary-500',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%20with%20warm%20crimson%20lighting%2C%20abstract%20product%20displays%2C%20digital%20screen%20glow%20effects%2C%20comment%20flood%20visualization%2C%20tense%20atmosphere%2C%20editorial%20style%2C%20clean%20composition%2C%20dramatic%20shadows&width=640&height=420&seq=carousel-04&orientation=landscape',
  },
  {
    title: '某男演员被前女友实名爆料家暴，聊天记录曝光',
    summary: '一位自称是某知名男演员前女友的网友在社交平台实名发长文，指控该男演员在恋爱期间存在家暴行为，并附上了大量聊天记录。',
    tag: '实名爆料',
    tagColor: 'bg-accent-500',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20smartphone%20screen%20displaying%20chat%20messages%20with%20warm%20crimson%20glow%2C%20abstract%20emotional%20atmosphere%2C%20dark%20ambient%20lighting%2C%20rainy%20window%20reflections%2C%20tense%20mood%2C%20editorial%20photography%20style%2C%20clean%20composition&width=640&height=420&seq=carousel-05&orientation=landscape',
  },
  {
    title: '某综艺节目剪辑被指恶意炒作，嘉宾集体发声明',
    summary: '某热门综艺最新一期播出后，多位参与录制的嘉宾联合发表声明，指责节目组恶意剪辑导致形象受损，引发全网热议。',
    tag: '综艺争议',
    tagColor: 'bg-secondary-500',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20TV%20studio%20scene%20with%20warm%20crimson%20and%20amber%20stage%20lighting%2C%20abstract%20multiple%20camera%20angles%2C%20editing%20suite%20visuals%2C%20tense%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20cinematic%20mood&width=640&height=420&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">焦点爆料</h2>
              <p className="text-sm text-foreground-600 mt-1">本周最受关注的六条猛料</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item, i) => (
              <article
                key={i}
                className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className={`px-2.5 py-1 rounded-full text-xs font-bold text-background-50 ${item.tagColor} whitespace-nowrap`}>
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-sm md:text-base text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                    {item.summary}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}